import styled from 'styled-components'

export const StyledStakeSection = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledStakeDescription = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
  padding: 16px;
  background: ${({ theme }) => theme.colors.bgBase};
  border-radius: 16px;

  .description-text {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.textCaption};
  }
`

// Form styles
export const StyledStakeForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const StyledFormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const StyledLabel = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textTitle};
`

export const StyledBalanceInfo = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.primary};
`

export const StyledReceiveInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const StyledInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyledInfoLabel = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textCaption};
  display: flex;
  align-items: center;
  gap: 4px;
`

export const StyledInfoValue = styled.div<{ color?: 'primary' }>`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme, color }) =>
    color === 'primary' ? theme.colors.primary : theme.colors.textTitle};
  display: flex;
  align-items: center;
  gap: 4px;
`

export const StyledStakedInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`

export const StyledStakedLabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

export const StyledPipe = styled.div`
  background: #beb8e2;
  width: 2px;
  height: 30px;
  margin-right: 8px;
  border-radius: 3px;
`

export const StyledStakedLabel = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
  color: ${({ theme }) => theme.colors.textCaption};
`

export const StyledStakedAmount = styled.div`
  margin-top: 4px;
  font-size: 12px;
  font-weight: 500;
  line-height: 140%;
  color: ${({ theme }) => theme.colors.textTitle};
`

export const StyledActionButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`

export const StyledActionButton = styled.button<{
  variant?: 'primary' | 'secondary'
}>`
  flex: 1;
  height: 34px;
  border-radius: 28px;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid;
  padding: 0 12px;
  background-color: transparent;
  cursor: pointer;

  ${({ theme, variant }) => {
    if (variant === 'primary') {
      return `
        border-color: ${theme.colors.primary};
        color: ${theme.colors.primary};
      `
    } else {
      return `
        border-color: ${theme.colors.btnNeutral};
        color: ${theme.colors.textTitle};
      `
    }
  }}

  &:disabled {
    border: none;
    color: #c4c9da;
    background-color: #eeedf3;
    cursor: not-allowed;
  }
`
